

export const analyticsID = 'G-3YE3CQSTXS';
export const tagID = 'GTM-NNWRD6R7';
